import React from 'react';
import { makeStyles } from 'vendor/material';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontSize: '14px',
    fontWeight: 'bold',
  },
}));

const NumberIcon = ({ index }: { index: number }) => {
  const classes = useStyles();
  return <div className={classes.root}>{index}</div>;
};

export default NumberIcon;
